export default __webpack_public_path__ + "static/media/driver.3cfe073d.svg";